import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '@ibank-globals/language';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../globals/classes/base.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'error-message-modal',
	template: require('./error-message-modal.component.html'),
})
export class ErrorMessageModalComponent extends BaseComponent implements OnInit {
	@Input() wrongCardPin: boolean = false;
	@Input() noMobileNumber: boolean = false;
	@Input() wrongEmail: boolean = false;
	@Input() confirmationDocumentsNotFound: boolean = false;
	@Input() email: string = '';

	@Input() title: string = undefined;
	@Input() body: string;
	@Input() action: string;
	@Input() iconImgSrc: string = './Content/icons/business-error-msg.svg';
	public isRebrading = AppSettings.isRebrading;
	public langId: string;
	constructor(private activeModal: NgbActiveModal, private _langSvc: LanguageService) {
		super();
	}

	public ngOnInit(): void {
		this._initSubscriptions();
	}
	public get showGeneralError(): boolean {
		if (
			this.wrongCardPin ||
			this.noMobileNumber ||
			this.wrongEmail ||
			this.confirmationDocumentsNotFound
		)
			return false;
		else return true;
	}

	public closeModal(): void {
		this.activeModal.close();
	}
	public findNBGStore(): string {
		if (this.langId === 'el') {
			return 'https://www.nbg.gr/el/Branches-ATMs';
		} else return 'https://www.nbg.gr/en/Branches-ATMs';
	}

	private _initSubscriptions(): void {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => (this.langId = lang));
	}
}
